import { createReducer, on } from '@ngrx/store';
import {
  deleteWorkflow,
  deleteWorkflowMail,
  getWorkflowData,
  getWorkflowMail,
  getWorkflows,
  saveWorkflow,
  saveWorkflowMail,
  saveWorkflowStepsOrder,
  setPossibleFields,
  setWorkflowData,
  setWorkflowMail,
  setWorkflows,
  setAllActors,
  setAllActions,
  setWorkflowDT,
  saveWorkflowOrderSuccess,
  saveWorkflowOrderFailure,
  setWorkflowsWithSorting,
  setPossibleFieldsForHide,
  getWorkflowInterimData,
  setWorkflowInterimData,
  deleteWorkflowInterimSuccess,
  deleteWorkflowInterimFailure
} from '../actions/workflow.actions';

export interface WorkflowState {
  commonProperties: any;
  workflows: any[];
}

export const initialState: WorkflowState = {
  commonProperties: {},
  workflows: []
};
export const workflowReducer = createReducer(
  initialState,
  on(getWorkflowData, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(getWorkflowInterimData, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(setWorkflowData, (state, { workflowData }) => ({
    ...state,
    ...{ workflowData }
  })),
  on(setWorkflowInterimData, (state, { workflowData }) => ({
    ...state,
    ...{ workflowData }
  })),
  on(setWorkflowDT, (state, { workflowDT }) => ({
    ...state,
    ...{ workflowDT }
  })),
  on(setAllActors, (state, { wfActors }) => ({
    ...state,
    ...{ wfActors }
  })),
  on(setAllActions, (state, { wfActions }) => ({
    ...state,
    ...{ wfActions }
  })),
  on(setPossibleFields, (state, { dynamicPossibleOptions }) => ({
    ...state,
    ...{ dynamicPossibleOptions }
  })),
  on(setPossibleFieldsForHide, (state, { dynamicPossibleOptionsForHide }) => ({
    ...state,
    ...{ dynamicPossibleOptionsForHide }
  })),
  on(getWorkflows, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(setWorkflows, (state, { workflows }) => ({
    ...state,
    ...{ workflows }
  })),
  on(setWorkflowsWithSorting, (state, { workflows }) => ({
    ...state,
    ...{ workflows }
  })),
  on(saveWorkflow, (state, { workflowReqData }) => ({
    ...state,
    ...workflowReqData
  })),
  on(deleteWorkflow, (state, { ids }) => ({
    ...state,
    ...ids
  })),
  on(saveWorkflowStepsOrder, (state, { workflowReqData }) => ({
    ...state,
    ...workflowReqData
  })),
  on(getWorkflowMail, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(setWorkflowMail, (state, { workflowMail }) => ({
    ...state,
    ...{ workflowMail }
  })),
  on(saveWorkflowMail, (state, { workflowMailData }) => ({
    ...state,
    ...workflowMailData
  })),
  on(deleteWorkflowMail, (state, { ids }) => ({
    ...state,
    ...ids
  })),
  on(saveWorkflowOrderSuccess, (state, { results }) => {
    return {
      ...state,
      results
    };
  }),
  on(saveWorkflowOrderFailure, (state, { error }) => {
    return {
      ...state,
      error
    };
  }),
  on(deleteWorkflowInterimSuccess, (state, { workflowId }) => {
    const filteredWorkflows: any[] = state?.workflows?.filter((workflow: any) => workflow.sid !== workflowId);
    return {
      ...state,
      workflows: filteredWorkflows
    };
  }),
  on(deleteWorkflowInterimFailure, (state, { error }) => {
    return {
      ...state,
      ...error
    };
  })
);
